import { render, staticRenderFns } from "./BillingDocumentStatementShowModal.vue?vue&type=template&id=95c3b196&"
import script from "./BillingDocumentStatementShowModal.vue?vue&type=script&lang=js&"
export * from "./BillingDocumentStatementShowModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports